import React, { useState } from 'react';
import { isDonorRole } from '../../utils/accountType';
import { useSelector } from 'react-redux';
import Sidebar from './Sidebar/Sidebar';
import TopHeader from './TopHeader/TopHeader';
import MobileBottomNav from './MobileBottomNav/MobileBottomNav';
import './DashboardLayout.css';
import { useLocation } from "react-router-dom";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const reduxOrg = useSelector((state: any) => state.org);
  const reduxUser = useSelector((state: any) => state.signin);
  const path = useLocation().pathname;
  // const [showSettingsModal, setShowSettingsModal] = React.useState<boolean>(false);

  const userRole = isDonorRole(reduxUser.type) ? 'individual' : 'nonprofit';
  const headerName = userRole === 'individual'
    ? `${reduxUser?.firstName || ''} ${reduxUser?.lastName || ''}`.trim() || 'User'
    : (reduxOrg?.name || 'Organization');

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

    const location = useLocation();
  const isDonorPage = location.pathname.includes("/donor");


  return (
    <div className="dashboard-layout">
      <Sidebar
        collapsed={sidebarCollapsed}
        mobileOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        onToggle={toggleSidebar}
        onMobileToggle={toggleMobileMenu}
        userRole={userRole}
        isMobile={false}
        // showSettingsModal={showSettingsModal}
        // setShowSettingsModal={setShowSettingsModal}
      />

      <div className={`${path.replace("/", "")} dashboard-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        {/* Conditionally render MobileTopBar if mobile screen and route is /donor/; hide TopHeader in this case */}
        {typeof window !== "undefined" && window.innerWidth <= 768 && path.startsWith('/donor/')
          ? (
            <div style={{ zIndex: 100, position: 'relative' }}>
              {require('../../components/common/MobileTopBar').default
                ? React.createElement(require('../../components/common/MobileTopBar').default)
                : null}
            </div>
          )
          : (
            <TopHeader
              organizationName={headerName}
              onMobileMenuToggle={toggleMobileMenu}
              // setShowSettingsModal={setShowSettingsModal}
            />
          )
        }

        <div className="dashboard-content" style={{
        padding: isDonorPage ? "0" : "",
      }}>
          {children}
        </div>
      </div>

      {/* Mobile overlay */}
      {mobileMenuOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {userRole === 'individual' && <MobileBottomNav />}
    </div>
  );
};

export default DashboardLayout;